import { APPLY_FDR_URL, APP_BASE_PATH } from 'src/common/constants'

const TITLE = 'Where we operate | Freedom Debt Relief'
const URL = `${APP_BASE_PATH()}/who-we-help/states/`
const DESCRIPTION =
  'Freedom Debt Relief is here for the millions of people who want to resolve debt fast, so they can live their life to the fullest.'

export const whoWeHelpStatesData = {
  seo: {
    noindex: false,
    nofollow: false,
    title: TITLE,
    description: DESCRIPTION,
    canonical: URL,
    openGraph: {
      title: TITLE,
      description: DESCRIPTION,
      url: URL,
      type: 'article',
      locale: 'en_US',
      article: {
        modifiedTime: '2020-04-07T23:27:48+00:00',
        authors: ['https://www.facebook.com/freedomdebtrelief'],
      },
      images: [
        {
          url: `${APP_BASE_PATH()}/next-assets/brand-pages/heros/desktop/who-we-help-states.webp`,
        },
      ],
    },
  },
}

export const data = {
  licenses: [
    {
      state: 'Arizona',
      licenseName: 'Telephone Solicitor',
      registrationNumber: '625428',
    },
    {
      state: 'Arkansas',
      licenseName: 'Telephonic Seller',
      registrationNumber: '625428',
    },
    {
      state: 'California',
      licenseName: 'Quarterly Report - Telephonic Seller Registration',
      registrationNumber: '12-2370',
    },
    {
      state: 'California',
      licenseName: 'Business Tax Cert',
      registrationNumber: 'BT-2020-116318',
    },
    {
      state: 'California',
      licenseName: 'Telephonic Seller Registration',
      registrationNumber: '12-2370',
    },
    {
      state: 'Colorado',
      licenseName: 'Debt Management Service Provider',
      registrationNumber: '000039',
    },
    {
      state: 'Delaware',
      licenseName: 'Debt Management Services',
      registrationNumber: '09-21',
    },
    {
      state: 'Florida',
      licenseName: 'Commercial Telephone Seller',
      registrationNumber: 'TC4118',
    },
    {
      state: 'Idaho',
      licenseName: 'Annual Report - Debt/Credit Counseling Agency',
      registrationNumber: 'CDS-8151',
    },
    {
      state: 'Idaho',
      licenseName: 'Debt/Credit Counseling Agency',
      registrationNumber:
        'CDS-8151 (Collection Agency License) &<br/>CDS-10206<br/>(Quarterly Notification of Agents/Collectors)',
    },
    {
      state: 'Indiana',
      licenseName:
        '1) Credit Services Organization <br/>(bond) <br/><br/>2)Telephone Solicitation',
      registrationNumber:
        '1) Bond No. 41201972 <br/><br/>2) C.P.D. Reg. N. TS. R2019',
    },
    {
      state: 'Iowa',
      licenseName: 'Debt Management',
      registrationNumber: 'DM-2010-0036 and DM-2009-0059',
    },
    {
      state: 'Kentucky',
      licenseName: 'DM-2010-0036 and DM-2009-0059',
      registrationNumber: 'File # 70',
    },
    {
      state: 'Maine',
      licenseName: 'Debt Management Service',
      registrationNumber: 'Registration #: DMS11185',
    },
    {
      state: 'Maryland',
      licenseName: 'Debt Settlement Service Provider',
      registrationNumber: 'Registration # 1',
    },
    {
      state: 'Maryland',
      licenseName: 'Annual Report - Debt Settlement Service Provider',
      registrationNumber: 'Registration # 1',
    },
    {
      state: 'Minnesota',
      licenseName: 'Debt Settlement Service Provider',
      registrationNumber: 'Registration Number: <br/>DS000001',
    },
    {
      state: 'Minnesota',
      licenseName: 'Annual Report - Debt Settlement Service Provider',
      registrationNumber: 'Registration Number: <br/>DS000001',
    },
    {
      state: 'Mississippi',
      licenseName: 'Commercial Telephone Seller Registration',
      registrationNumber: 'CS-19-00769',
    },
    {
      state: 'Missouri',
      licenseName: 'Debt adjuster (bond)',
      registrationNumber: 'n/a',
    },
    {
      state: 'Montana',
      licenseName: 'Consumer Debt Settlement Certificate',
      registrationNumber: 'Registration #: 184936',
    },
    {
      state: 'Nevada',
      licenseName: 'Debt Management Services Provider',
      registrationNumber: 'DMSM11043',
    },
    {
      state: 'Pennsylvania',
      licenseName: 'Debt Settlement',
      registrationNumber:
        '49860 (original license) <br/>4986.001 (Branch License)',
    },
    {
      state: 'Pennsylvania',
      licenseName: 'Debt Settlement Services Annual Report',
      registrationNumber: '49860',
    },
    {
      state: 'South Dakota',
      licenseName: 'Debt Adjusting (Bond)',
      registrationNumber: 'Bond #: 41151561',
    },
    {
      state: 'Tennessee',
      licenseName: 'Debt Management Services Provider',
      registrationNumber: 'ID # 60',
    },
    {
      state: 'Texas',
      licenseName: 'Debt Management Service Provider',
      registrationNumber: '125696',
    },
    {
      state: 'Texas',
      licenseName: 'Telephone Solicitation Registration',
      registrationNumber: 'Telemarketing File Number: 20110007',
    },
    {
      state: 'Utah',
      licenseName:
        '1) Debt Management Service <br/><br/>2) Telephone Solicitation<br/>     Registration',
      registrationNumber: '1) 7164298-DBTM; <br/><br/>2) 8157752-TLM0',
    },
  ],
}
